export default {
  // layer data changed, event will have .layerData and .layerName
  layerData: 'layerData',
  // selection changed, event will have .selected
  selection: 'selection',
  // extent changed, event will have .extent
  extentChange: 'extentChange',
  // visibility changed, event will have .layerVisibility as a map of {[layername]: true/false}
  visibilityChange: 'visibilityChange',
  // draw event end, dispatch drew feature
  drawEnd: 'drawEnd'
};